import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function LearnerGate() {
  const { token } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      localStorage.setItem("dec_learner_token", token);
      try {
        await api.get("/learner/me");
        navigate("/learner", { replace: true });
      } catch (e) {
        localStorage.removeItem("dec_learner_token");
        toast.error("Ce lien n'est pas valide ou a été révoqué.");
        navigate("/", { replace: true });
      }
    })();
  }, [token, navigate]);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF8F5]">
      <div className="text-[#5C6561]">Ouverture de votre espace…</div>
    </div>
  );
}
